// extracted by mini-css-extract-plugin
module.exports = {"productDetailWrapper":"SpecsItem_productDetailWrapper__3ZvQK","theme_white":"SpecsItem_theme_white__Hg5hk","theme_black":"SpecsItem_theme_black__oFko2"};